export const transformTags = tagObjectArray => {
  let tagStringArray = []

  tagObjectArray.forEach(tagObject => tagStringArray.push(tagObject.tag))

  return tagStringArray
}
